'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _headerText = require('./header-text');

var _headerText2 = _interopRequireDefault(_headerText);

var _headerButton = require('./header-button');

var _headerButton2 = _interopRequireDefault(_headerButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var outlineStyle = { outline: '8px auto #3b99fc' };
var isComponentOutlined = function isComponentOutlined(props, component) {
    return props.selectedComponent === component;
};

module.exports = function (_React$Component) {
    _inherits(DocumentHeader, _React$Component);

    function DocumentHeader(props) {
        _classCallCheck(this, DocumentHeader);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DocumentHeader).call(this, props));

        _this.intervals = [];
        _this.name = 'Header';

        _this.state = {
            'selectedComponent': null,
            'isHeaderOutlined': false,
            'isBlinking': true,
            'colors': {
                'Header': '#000000',
                'HeaderText': '#FFFFFF',
                'Button': '#00B3E6',
                'ButtonText': '#FFFFFF'
            }
        };
        return _this;
    }

    _createClass(DocumentHeader, [{
        key: 'clearIntervals',
        value: function clearIntervals() {
            this.intervals.forEach(clearInterval);
            this.intervals = [];
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var blink = function blink() {
                return _this2.setState({ isHeaderOutlined: !_this2.state.isHeaderOutlined });
            };
            this.intervals.push(setInterval(blink, 500));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearIntervals();
        }
    }, {
        key: 'handleClick',
        value: function handleClick(event, component) {
            event.stopPropagation();
            var newState = Object.assign({}, this.state, { selectedComponent: component });
            if (this.state.isBlinking) {
                this.clearIntervals();
                newState.isHeaderOutlined = false;
                newState.isBlinking = false;
                this.props.changeBlinkingComponent('DocumentHeader');
            }
            this.props.setColor(this.state.colors[component]);
            this.setState(newState);
        }
    }, {
        key: 'getColors',
        value: function getColors() {
            var colors = this.state.colors;
            colors[this.state.selectedComponent] = this.props.selectedColor;
            return colors;
        }
    }, {
        key: 'getStyle',
        value: function getStyle(colors) {
            var state = this.state;
            var headerStyle = {
                'backgroundColor': colors[this.name]
            };
            if (state.isHeaderOutlined || isComponentOutlined(state, this.name)) {
                headerStyle = Object.assign(headerStyle, outlineStyle);
            }
            return headerStyle;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var colors = this.getColors();
            var headerStyle = this.getStyle(colors);
            var props = _extends({
                handleClick: this.handleClick.bind(this),
                colors: colors,
                isComponentOutlined: isComponentOutlined,
                outlineStyle: outlineStyle
            }, this.state);

            return _jsx('div', {
                className: 'm-document-header',
                onClick: function onClick(event) {
                    return _this3.handleClick(event, _this3.name);
                },
                style: headerStyle
            }, void 0, _jsx('div', {
                className: 'm-document-header-left'
            }, void 0, _jsx('div', {}, void 0, _jsx('img', {
                src: require('./assets/your_logo.png'),
                'aria-hidden': true
            })), _react2['default'].createElement(_headerText2['default'], props)), _jsx('div', {
                className: 'm-document-header-right'
            }, void 0, _react2['default'].createElement(_headerButton2['default'], props)));
        }
    }]);

    return DocumentHeader;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/document-header.jsx
 ** module id = 872
 ** module chunks = 0
 **/